import { Outlet, createRootRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/AppShell';

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
});

function RootLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

function NotFound() {
  return (
    <AppShell>
      <main>
        <h1>This page is not in this book.</h1>
        <p className="muted">Try the search, or begin again at the beginning.</p>
        <p>
          <a href="/read/GEN/1">Genesis 1 →</a>
        </p>
      </main>
    </AppShell>
  );
}
